// React&NextJS
import React, { useState } from 'react'
// Context&Auth
import { useAuth } from '../../../../context/UserContext'
// Types
import { Settings } from '../../../../types/types'
// Styles
import s from './UserProfile.module.scss'
// Components
import { Button } from '../../../core/button/Button'
import { Text } from '../../../core/text/Text'
import { Icon } from '../../../core/icon/Icon'
import { Input } from '../../../core/input/Input'
import { ProfileFormFooter } from '../../../forms/memoryForm/formFooter/ProfileFormFooter'
import firestoreEditService from '../../../../services/edit'

type Props = {
    settings: Settings
    updateProfileSettings: Function
}

function UserProfile({ settings, updateProfileSettings }: Props) {
    const { user } = useAuth()
    const [userSettings, setUserSettings] = useState<Settings>(
        settings
            ? {
                  mailAnnouncements: settings.mailAnnouncements,
                  obitAnnouncements: settings.obitAnnouncements,
                  condAnnouncements: settings.condAnnouncements,
                  annoAnnouncements: settings.annoAnnouncements,
              }
            : null
    )
    const [settingsChanged, setSettingsChanged] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const SubmitHandler = async (e: React.FormEvent) => {
        e.preventDefault()
        setIsLoading(true)

        await firestoreEditService
            .editSendgridEmail(user.email, user.email, userSettings, {
                mailAnnouncements: settings.mailAnnouncements,
                obitAnnouncements: settings.obitAnnouncements,
                condAnnouncements: settings.condAnnouncements,
                annoAnnouncements: settings.annoAnnouncements,
            })
            .then(() => {
                updateProfileSettings({
                    ...settings,
                })
            })
        setSettingsChanged(false)
        setIsLoading(false)
    }

    const updateAnnouncements = () => {
        const newSettings = {
            ...userSettings,
            obitAnnouncements: !userSettings.obitAnnouncements,
            condAnnouncements: !userSettings.condAnnouncements,
        }

        // Update state
        setUserSettings({ ...newSettings })
        if (!settingsChanged) setSettingsChanged(true)
    }

    const updateAnnoAnnouncements = () => {
        const newSettings = {
            ...userSettings,
            annoAnnouncements: !userSettings.annoAnnouncements,
        }

        // Update state
        setUserSettings({ ...newSettings })
        if (!settingsChanged) setSettingsChanged(true)
    }

    const cancel = () => {
        setSettingsChanged(false)
        setUserSettings({
            mailAnnouncements: settings.mailAnnouncements,
            obitAnnouncements: settings.obitAnnouncements,
            condAnnouncements: settings.condAnnouncements,
            annoAnnouncements: settings.condAnnouncements,
        })
    }

    return (
        <>
            <div className={s.default}>
                <Text variant="h6">{user.name}</Text>
                {user.phone && (
                    <Text variant="h6">Símanúmer: {user.phone}</Text>
                )}

                <div className={s.emailInfo}>
                    <Text variant="h6">Netfang: {user.email}</Text>
                    <Button
                        to="/account/email-change"
                        variant="ghost"
                        className={s.emailBtn}
                    >
                        <Icon variant="edit" width="14" height="14" />
                    </Button>
                </div>
            </div>
            {settings && (
                <>
                    <form
                        className={s.announcements}
                        id="profile-form"
                        onSubmit={SubmitHandler}
                    >
                        <Input
                            type="checkbox"
                            id="obitAnnouncements"
                            name="obitAnnouncements"
                            label="Ég vil fá senda tilkynningu þegar ný minningargrein eða skilaboð eru skrifuð við minningarsíðu í minni umsjón."
                            disabled={isLoading}
                            onChange={() => updateAnnouncements()}
                            checked={userSettings.obitAnnouncements}
                        />
                        <Input
                            type="checkbox"
                            id="annoAnnouncements"
                            name="annoAnnouncements"
                            label="Ég vil fá senda tilkynningu um næstu skref við gerð minningarsíðna."
                            disabled={isLoading}
                            onChange={() => updateAnnoAnnouncements()}
                            checked={userSettings.annoAnnouncements}
                        />
                    </form>
                    <div className={s.mailBoxes}>
                        <Button
                            type="button"
                            name="mailAnnouncements"
                            variant="text"
                            to="/account/mail-list"
                        >
                            {settings.mailAnnouncements
                                ? 'Skrá mig af póstlista Minningar.is'
                                : 'Skrá mig á póstlista Minningar.is'}
                        </Button>
                    </div>
                </>
            )}
            {!settings && (
                <div className={s.mailBoxes}>
                    <Text variant="p-small">
                        Ekki náðist að sækja netfangsupplýsingar...
                    </Text>
                </div>
            )}
            {settingsChanged && (
                <ProfileFormFooter
                    formID="profile-form"
                    cancel={cancel}
                    isLoading={isLoading}
                />
            )}
        </>
    )
}

export default UserProfile
